import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
 ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  Search,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];
// Structure des données hiérarchisées
const populationData = {
  title: "Répartition de la population résidente des ménages ordinaires par sexe, province, commune selon le milieu de résidence et la proportion du milieu de résidence",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", total: "109 714", urbain: "4 566", rural: "105 148", proportionUrbain: "4,2", proportionRural: "95,8" },
        { name: "BUTIHINDA", total: "433 228", urbain: "42 759", rural: "390 469", proportionUrbain: "9,9", proportionRural: "90,1" },
        { name: "CANKUZO", total: "159 901", urbain: "17 699", rural: "142 202", proportionUrbain: "11,1", proportionRural: "88,9" },
        { name: "GISAGARA", total: "290 800", urbain: "10 336", rural: "280 464", proportionUrbain: "3,6", proportionRural: "96,4" },
        { name: "GISURU", total: "336 599", urbain: "28 446", rural: "308 153", proportionUrbain: "8,5", proportionRural: "91,5" },
        { name: "MUYINGA", total: "492 100", urbain: "91 074", rural: "401 026", proportionUrbain: "18,5", proportionRural: "81,5" },
        { name: "RUYIGI", total: "219 074", urbain: "30 439", rural: "188 635", proportionUrbain: "13,9", proportionRural: "86,1" }
      ],
      total: "2 041 416",
      urbain: "225 319",
      rural: "1 816 097",
      proportionUrbain: "11,0",
      proportionRural: "89,0"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", total: "238 953", urbain: "63 489", rural: "175 464", proportionUrbain: "26,6", proportionRural: "73,4" },
        { name: "BUKINANYANA", total: "268 083", urbain: "67 764", rural: "200 319", proportionUrbain: "25,3", proportionRural: "74,7" },
        { name: "CIBITOKE", total: "259 136", urbain: "147 686", rural: "111 450", proportionUrbain: "57,0", proportionRural: "43,0" },
        { name: "ISARE", total: "149 026", urbain: "6 123", rural: "142 903", proportionUrbain: "4,1", proportionRural: "95,9" },
        { name: "MPANDA", total: "358 910", urbain: "142 976", rural: "215 934", proportionUrbain: "39,8", proportionRural: "60,2" },
        { name: "MUGERE", total: "507 543", urbain: "317 399", rural: "190 144", proportionUrbain: "62,5", proportionRural: "37,5" },
        { name: "MUGINA", total: "224 695", urbain: "39 656", rural: "185 039", proportionUrbain: "17,6", proportionRural: "82,4" },
        { name: "MUHUTA", total: "117 027", urbain: "26 237", rural: "90 790", proportionUrbain: "22,4", proportionRural: "77,6" },
        { name: "MUKAZA", total: "159 166", urbain: "122 958", rural: "36 208", proportionUrbain: "77,3", proportionRural: "22,7" },
        { name: "NTAHANGWA", total: "912 866", urbain: "809 162", rural: "103 704", proportionUrbain: "88,6", proportionRural: "11,4" },
        { name: "RWIBAGA", total: "115 838", urbain: "5 013", rural: "110 825", proportionUrbain: "4,3", proportionRural: "95,7" }
      ],
      total: "3 311 243",
      urbain: "1 748 463",
      rural: "1 562 780",
      proportionUrbain: "52,8",
      proportionRural: "47,2"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", total: "182 930", urbain: "10 112", rural: "172 818", proportionUrbain: "5,5", proportionRural: "94,5" },
        { name: "MAKAMBA", total: "368 668", urbain: "74 963", rural: "293 705", proportionUrbain: "20,3", proportionRural: "79,7" },
        { name: "MATANA", total: "191 889", urbain: "11 942", rural: "179 947", proportionUrbain: "6,2", proportionRural: "93,8" },
        { name: "MUSONGATI", total: "335 150", urbain: "36 949", rural: "298 201", proportionUrbain: "11,0", proportionRural: "89,0" },
        { name: "NYANZA", total: "366 682", urbain: "112 582", rural: "254 100", proportionUrbain: "30,7", proportionRural: "69,3" },
        { name: "RUMONGE", total: "426 929", urbain: "127 317", rural: "299 612", proportionUrbain: "29,8", proportionRural: "70,2" },
        { name: "RUTANA", total: "225 607", urbain: "43 244", rural: "182 363", proportionUrbain: "19,2", proportionRural: "80,8" }
      ],
      total: "2 097 855",
      urbain: "417 109",
      rural: "1 680 746",
      proportionUrbain: "19,9",
      proportionRural: "80,1"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", total: "357 399", urbain: "23 227", rural: "334 172", proportionUrbain: "6,5", proportionRural: "93,5" },
        { name: "KAYANZA", total: "330 304", urbain: "54 501", rural: "275 803", proportionUrbain: "16,5", proportionRural: "83,5" },
        { name: "KIREMBA", total: "291 246", urbain: "16 959", rural: "274 287", proportionUrbain: "5,8", proportionRural: "94,2" },
        { name: "KIRUNDO", total: "476 758", urbain: "38 350", rural: "438 408", proportionUrbain: "8,0", proportionRural: "92,0" },
        { name: "MATONGO", total: "264 736", urbain: "7 668", rural: "257 068", proportionUrbain: "2,9", proportionRural: "97,1" },
        { name: "MUHANGA", total: "222 657", urbain: "17 078", rural: "205 579", proportionUrbain: "7,7", proportionRural: "92,3" },
        { name: "NGOZI", total: "312 366", urbain: "116 156", rural: "196 210", proportionUrbain: "37,2", proportionRural: "62,8" },
        { name: "TANGARA", total: "263 007", urbain: "9 998", rural: "253 009", proportionUrbain: "3,8", proportionRural: "96,2" }
      ],
      total: "2 518 473",
      urbain: "283 937",
      rural: "2 234 536",
      proportionUrbain: "11,3",
      proportionRural: "88,7"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", total: "228 556", urbain: "10 673", rural: "217 883", proportionUrbain: "4,7", proportionRural: "95,3" },
        { name: "GISHUBI", total: "242 753", urbain: "6 370", rural: "236 383", proportionUrbain: "2,6", proportionRural: "97,4" },
        { name: "GITEGA", total: "514 822", urbain: "212 680", rural: "302 142", proportionUrbain: "41,3", proportionRural: "58,7" },
        { name: "KARUSI", total: "376 731", urbain: "23 999", rural: "352 732", proportionUrbain: "6,4", proportionRural: "93,6" },
        { name: "KIGANDA", total: "148 621", urbain: "9 079", rural: "139 542", proportionUrbain: "6,1", proportionRural: "93,9" },
        { name: "MURAMVYA", total: "166 104", urbain: "29 345", rural: "136 759", proportionUrbain: "17,7", proportionRural: "82,3" },
        { name: "MWARO", total: "145 590", urbain: "10 677", rural: "134 913", proportionUrbain: "7,3", proportionRural: "92,7" },
        { name: "NYABIHANGA", total: "175 076", urbain: "5 784", rural: "169 292", proportionUrbain: "3,3", proportionRural: "96,7" },
        { name: "SHOMBO", total: "253 705", urbain: "7 036", rural: "246 669", proportionUrbain: "2,8", proportionRural: "97,2" }
      ],
      total: "2 251 958",
      urbain: "315 643",
      rural: "1 936 315",
      proportionUrbain: "14,0",
      proportionRural: "86,0"
    }
  ],
  sexes: [
    { name: "MASCULIN", total: "5 823 080", urbain: "1 478 769", rural: "4 344 311", proportionUrbain: "25,4", proportionRural: "74,6" },
    { name: "FEMININ", total: "6 397 864", urbain: "1 511 702", rural: "4 886 162", proportionUrbain: "23,6", proportionRural: "76,4" }
  ],
  total: {
    total: "12 220 934",
    urbain: "2 990 471",
    rural: "9 230 473",
    proportionUrbain: "24,5",
    proportionRural: "75,5"
  }
};

const PopulationResidentPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };
  // Calcul des indicateurs clés
  const keyStats = {
    totalPopulation: populationData.total.total,
    urbanPercentage: populationData.total.proportionUrbain,
    ruralPercentage: populationData.total.proportionRural,
    
    mostUrbanProvince: populationData.provinces.reduce((max, province) => 
      parseFloat(province.proportionUrbain) > parseFloat(max.proportionUrbain) ? province : max
    ),
    
    mostRuralProvince: populationData.provinces.reduce((min, province) => 
      parseFloat(province.proportionUrbain) < parseFloat(min.proportionUrbain) ? province : min
    ),
    
    genderUrbanGap: (
      parseFloat(populationData.sexes[0].proportionUrbain) - 
      parseFloat(populationData.sexes[1].proportionUrbain)
    ).toFixed(1),
    
    highestUrbanCommune: populationData.provinces.flatMap(p => p.communes).reduce((max, commune) => 
      parseFloat(commune.proportionUrbain) > parseFloat(max.proportionUrbain) ? commune : max
    ),
    
    lowestUrbanCommune: populationData.provinces.flatMap(p => p.communes).reduce((min, commune) => 
      parseFloat(commune.proportionUrbain) < parseFloat(min.proportionUrbain) ? commune : min
    )
  };

 
  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
     <MainContainer>
          <CssBaseline />
          <NavigationBar />
          <MainContentWithDrawer>
            {!isMobile ? (
              <DrawerWrapper>
                {drawer}
              </DrawerWrapper>
            ) : (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                {drawer}
              </Drawer>
            )}
    
            <ContentWrapper>
              <Container maxWidth="lg">
                {isMobile && (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <Button 
                      variant="outlined" 
                      startIcon={<MenuIcon />} 
                      onClick={handleDrawerToggle}
                      sx={{ color: primaryColor, borderColor: primaryColor }}
                    >
                      Menu
                    </Button>
                  </Box>
                )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                  </Box>
                    <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                        <Grid item xs={12} sm={6} md={6} ></Grid>
                          <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                   </Grid>
                   </Grid>
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {populationData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Ménages ordinaires
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {populationData.total.proportionUrbain}%
                              </Typography>
                              <Typography variant="caption">
                                {populationData.total.urbain} personnes
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus urbanisée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostUrbanProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostUrbanProvince.proportionUrbain}%
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({keyStats.mostUrbanProvince.urbain})
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Écart urbain H-F
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.genderUrbanGap} points
                              </Typography>
                              <Typography variant="caption">
                                Plus d'hommes en ville
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Urbain</TableCell>
                          <TableCell align="right">Rural</TableCell>
                          <TableCell align="right">% Urbain</TableCell>
                          <TableCell align="right">% Rural</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.urbain}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.rural}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.proportionUrbain}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.proportionRural}</TableCell>
                        </ProvinceRow>

                        {/* Données par sexe */}
                        {populationData.sexes.map((sex, idx) => (
                          <ProvinceRow key={idx} hover>
                            <TableCell component="th" scope="row" sx={{ pl: 2 }}>
                              {sex.name}
                            </TableCell>
                            <TableCell align="right">{sex.total}</TableCell>
                            <TableCell align="right">{sex.urbain}</TableCell>
                            <TableCell align="right">{sex.rural}</TableCell>
                            <TableCell align="right">{sex.proportionUrbain}</TableCell>
                            <TableCell align="right">{sex.proportionRural}</TableCell>
                          </ProvinceRow>
                        ))}

                        {/* Données par province et commune */}
                        {populationData.provinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                              <TableCell align="right">{province.urbain}</TableCell>
                              <TableCell align="right">{province.rural}</TableCell>
                              <TableCell align="right">{province.proportionUrbain}</TableCell>
                              <TableCell align="right">{province.proportionRural}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={6}>
                                <Collapse in={expandedProvinces[province.name]} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                          <TableCell align="right">{commune.urbain}</TableCell>
                                          <TableCell align="right">{commune.rural}</TableCell>
                                          <TableCell align="right">{commune.proportionUrbain}</TableCell>
                                          <TableCell align="right">{commune.proportionRural}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
</Paper>

{/* Section d'information */}
<Accordion sx={{ mb: 2 }}>
  <AccordionSummary expandIcon={<ExpandMore />}>
    <Typography variant="subtitle2" color="primary">
      À propos des ménages ordinaires
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography variant="body2" paragraph>
      Les ménages ordinaires représentent la population vivant dans des habitations classiques, répartie entre milieu urbain et rural.
    </Typography>
    <Typography variant="body2" paragraph>
      Principales caractéristiques :
    </Typography>
    <List dense sx={{ py: 0 }}>
      <ListItem>
        <ListItemText primary="• Familles vivant dans des maisons individuelles" />
      </ListItem>
      <ListItem>
        <ListItemText primary="• Personnes vivant en appartement" />
      </ListItem>
      <ListItem>
        <ListItemText primary="• Communautés villageoises" />
      </ListItem>
      <ListItem>
        <ListItemText primary="• Quartiers urbains et périurbains" />
      </ListItem>
    </List>
    <Typography variant="body2" mt={2}>
      Ces données représentent {populationData.total.total} personnes, avec {populationData.total.proportionUrbain}% en milieu urbain et {populationData.total.proportionRural}% en milieu rural.
    </Typography>
  </AccordionDetails>
</Accordion>

{/* Notes méthodologiques */}
<Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
  <Typography variant="subtitle2" gutterBottom color="primary">
    Notes méthodologiques
  </Typography>
  <Typography variant="body2" color="text.secondary">
    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, 
    de l'Agriculture et Elevage (RGPHAE) réalisé en 2024. Elles couvrent l'ensemble de la population 
    résidente des ménages ordinaires du Burundi, avec une distinction entre milieux urbain et rural.
  </Typography>
</Paper>
</Grid>
</Grid>
</Container>
</ContentWrapper>
</MainContentWithDrawer>
<Footer />
</MainContainer>
);
};

export default PopulationResidentPage;